module.exports = __webpack_public_path__ + "static/media/naishadh_vora.f2b994d4.jpg";